// @ts-strict-ignore
type Listener = () => void;

const listeners = [] as Array<Listener>;
export const addDarkModeChangedListener = (listener: Listener) => {
    listeners.push(listener);
};

export const useDarkMode = (): [boolean, (boolean) => void] => {
    const localStorage = window.localStorage;

    const darkMode = localStorage?.getItem('darkMode') === 'true';
    const setDarkMode = (enabled: boolean) => {
        localStorage?.setItem('darkMode', enabled ? 'true' : 'false');
        listeners.forEach((listener) => listener());
    };
    return [darkMode, setDarkMode];
};
